var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.82l-5.057 3.038a.938.938 0 01-.566.138c-.19-.017-.36-.08-.514-.19a1.09 1.09 0 01-.355-.43.837.837 0 01-.04-.586l1.343-5.72-4.465-3.848a.952.952 0 01-.319-.502.905.905 0 01.036-.554c.07-.18.171-.326.303-.44.132-.113.312-.188.54-.223l5.892-.512 2.287-5.4a.88.88 0 01.379-.447 1.068 1.068 0 011.072 0 .88.88 0 01.379.446l2.287 5.4 5.892.513c.228.035.408.11.54.223.132.114.233.26.303.44.07.18.082.364.036.554a.952.952 0 01-.32.502L17.19 14.07l1.342 5.719a.837.837 0 01-.04.587 1.09 1.09 0 01-.355.43c-.153.109-.325.172-.514.19a.938.938 0 01-.566-.139L12 17.821z",
    fill: "currentColor"
  })));
}
SvgStarFilled.displayName = 'StarFilled';
export default SvgStarFilled;